import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductFeatureMutation($productFeature: ProductFeatureInput!) {
    createProductFeature(input: { productFeature: $productFeature }) {
      productFeature {
        id
        producerId
      }
    }
  }
`;
